import {Injectable, Pipe, PipeTransform} from '@angular/core'
import * as moment from 'moment-timezone'
moment.locale('fr')

@Pipe({
  name: 'ldToTimezone'
})
@Injectable()
export class ToTimezonePipe implements PipeTransform {
  transform (date: moment.Moment, tzName: string = 'Etc/Greenwich'): moment.Moment {
    return typeof date === 'undefined' || !date
      ? null
      : moment.tz(date.toISOString(), tzName)
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/pipes/to-timezone.pipe.ts